import React, { Fragment, useState } from "react";
import { useField, useFormikContext } from "formik";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import { toInputUppercase } from "../../../helpers/helpers";
import { client } from "../../../App";
import { GET_IBAN_VALIDATION } from "../../../helpers/queries";
import "./IbanField.scss";
import Modal from "../../common/Modal/Modal";

const ModalInfo = (props) => {
  return (
    <Modal
      show={true}
      content={
        <div className="success-modal-text paragraph-main-fs8">
          <p className="content">{props.content}</p>
        </div>
      }
      type={"button"}
      onFirstClick={() => props.open(false)}
      linkTitle={props.buttonText}
    />
  );
};
export default function IbanField(props) {
  const [showInfo, setShowInfo] = useState(false);
  const { label, options, placeholder, validationSchema, ...rest } = props;
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);
  const { summaryMode } = rest;
  const { t } = useTranslation();
  const hasIcon = props.leftIcon ? "has-icon" : "";
  let labelFormatted = label;
  const [first, second] = rest.relatedInfo || [];
  const { bankName = null } = first || {};
  const { agency = null } = second || {};
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;
  let { value } = meta;
  if (value) {
    value = value.replace(/ /g, "");
    console.log(value, "value");
    console.log(value.length, "length");
  }
  const [validationDone, setValidationDone] = useState(false);
  if (summaryMode) {
    labelFormatted = rest.summaryLabel ? rest.summaryLabel : props.label;
  }
  const ibanValidation = async (value) => {
    console.log(value.length, "value1");
    if (value.length === 27) {
      await new Promise((resolve, reject) => {
        client()
          .query({
            query: GET_IBAN_VALIDATION,
            variables: {
              iban: value,
            },
            fetchPolicy: "network-only",
          })
          .then((result) => {
            return result;
          })
          .then((result) => {
            if (
              result &&
              result.data &&
              result.data.ibanCheck &&
              result.data.ibanCheck.outcome &&
              result.data.ibanCheck.outcome === "success"
            ) {
              if (bankName && agency) {
                setFieldValue(bankName, result.data.ibanCheck.details.bank);
                setFieldValue(agency, result.data.ibanCheck.details.branch);
              }
              setValidationDone(true);
              resolve(result);
            } else {
              setValidationDone(false);
              setShowInfo(true);
              reject();
            }
          })
          .catch((error) => {
            setValidationDone(false);
            setShowInfo(true);
            setFieldValue(bankName, "-");
            setFieldValue(agency, "-");
          });
      });
    }
  };
  return (
    <Form.Group className="iban-form-group">
      {!summaryMode ? (
        <>
          {field.name && (
            <Form.Label className="paragraph-small-fs9" htmlFor={field.name}>
              {labelFormatted}
            </Form.Label>
          )}
          <Fragment>
            <InputGroup className={"mb-12"}>
              <Form.Control
                type="text"
                name={field.name}
                onPaste={rest.onPaste ? (e) => e.preventDefault() : () => {}}
                onCopy={rest.onCopy ? (e) => e.preventDefault() : () => {}}
                placeholder={
                  typeof rest.placeholder === "object"
                    ? t(rest.placeholder.props.i18nKey)
                    : rest.placeholder
                }
                value={field.value.replace(/ /g, "") || ""}
                onChange={field.onChange}
                className={
                  meta.touched && meta.error
                    ? `is-invalid`
                    : `` + field.value
                    ? ""
                    : "iban-empty"
                }
                disabled={rest.disabled}
                readOnly={rest.readonly}
                onInput={rest.uppercase ? toInputUppercase : null}
                isValid={validationDone}
                aria-describedby={
                  meta.touched && meta.error ? field.name + "-error" : null
                }
                required={isRequired}
                id={field.name}
              />
              <Button
                className="iban-field-btn"
                type="button"
                onClick={() => ibanValidation(value)}
              >
                {rest.labelButton}
              </Button>
            </InputGroup>
            {meta.touched && meta.error && (
              <p
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {meta.error}
              </p>
            )}
            {rest.leftIcon && (
              <i className={rest.leftIcon} aria-hidden="true"></i>
            )}
          </Fragment>
        </>
      ) : (
        <>
          {field.name && (
            <span className="paragraph-small-fs9">
              {labelFormatted}
            </span>
          )}
          <SummaryItem value={field.value} error={meta.error} />
        </>
      )}
      {props.subtitle ? (
        <p className="paragraph-small-form">{props.subtitle}</p>
      ) : null}
      {showInfo && (
        <ModalInfo
          content={rest.modalInfoContent}
          buttonText={rest.modalInfoButtonText}
          open={(value) => setShowInfo(value)}
        />
      )}
    </Form.Group>
  );
}
